<template>
  <div>
    <el-table :data="dataList" v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="name" label="培训人员" width="120" align="center"/>
      <el-table-column prop="gender" label="性别" width="70" align="center">
        <template slot-scope="scope">{{scope.row.gender==1?'男':scope.row.gender==2?'女':''}}</template>
      </el-table-column>
      <el-table-column prop="certificatesNumber" label="证件号" width="190" align="center"/>
      <el-table-column prop="mobilePhone" label="手机号" width="140" align="center"/>
      <el-table-column label="培训时间" align="center" width="200">
        <template slot-scope="scope">
          {{toDate(scope.row.hostStartTime,'yyyy-MM-dd')}}至{{toDate(scope.row.hostEndTime,'yyyy-MM-dd')}}
        </template>
      </el-table-column>
      <el-table-column label="培训地址" align="center">
        <template slot-scope="scope">
          {{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {trainSignPersonnelGetApplyPersonList} from "../../api/train";

export default {
  name: "trainPerson.vue",
  props:['eventsId','orderNo'],
  data(){
    return{
      dataList:[],
      params: {
        size: 1000,
        current: 1,
        name: '',
        trainId:'',
        orderNo:'',
      },
      listLoading:false
    }
  },
  created() {
    this.params.trainId = this.eventsId
    this.params.orderNo = this.orderNo
    this.listLoading = true
    // this.$store.commit("showLoading");
    trainSignPersonnelGetApplyPersonList(this.params).then(res=>{
      this.dataList = res.data.list
      this.listLoading = false
      // this.$store.commit("hideLoading");
    }).catch(()=>{
      // this.$store.commit("hideLoading");
      this.listLoading = false
    })
  }
}
</script>

<style scoped>

</style>
